import { render, staticRenderFns } from "./StoricoPOD.vue?vue&type=template&id=0d59710e"
import script from "./StoricoPOD.vue?vue&type=script&lang=js"
export * from "./StoricoPOD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports